module.exports = __webpack_public_path__ + "img/home-contactus.3efa6dd3.png";